export default __webpack_public_path__ + "static/media/Footwraps of the Forsaken.5774a012.jpg";